import { render, staticRenderFns } from "./admin-booking-grid-footer.vue?vue&type=template&id=6688436c"
import script from "./admin-booking-grid-footer.vue?vue&type=script&lang=js"
export * from "./admin-booking-grid-footer.vue?vue&type=script&lang=js"
import style0 from "./admin-booking-grid-footer.vue?vue&type=style&index=0&id=6688436c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports